module.exports = require("to-markdown");


//////////////////
// WEBPACK FOOTER
// external "to-markdown"
// module id = 12
// module chunks = 0